import { ICTLayout, DeltaOf } from '@tencent/slide-sdk-model';
import { DeepPartial, DeepReadonly } from 'ts-essentials';
import {
    IChartManualLayout,
} from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-properties.interface';

export class ChartLayoutConverter {
    public static convertPartialDataFromSdkToUi(
        sdkData: DeepReadonly<DeepPartial<ICTLayout>>,
        uiData: IChartManualLayout,
    ) {
        // TODO 如果ui2sdk也走这里，如果是removeProps可能有问题。不确定mutation这套有没有问题，后面留意下
        const sdkLayout = sdkData.manualLayout;
        if (sdkLayout) {
            if (sdkLayout.xMode) {
                uiData.leftMode = sdkLayout.xMode.val;
            }
            if (sdkLayout.yMode) {
                uiData.topMode = sdkLayout.yMode.val;
            }

            if (sdkLayout.x) {
                uiData.left = sdkLayout.x.val;
            } else {
                delete uiData.left;
            }
            if (sdkLayout.y) {
                uiData.top = sdkLayout.y.val;
            } else {
                delete uiData.top;
            }
            if (sdkLayout.w) {
                uiData.width = sdkLayout.w.val;
            } else {
                delete uiData.width;
            }
            if (sdkLayout.h) {
                uiData.height = sdkLayout.h.val;
            } else {
                delete uiData.height;
            }
        }
    }

    public static convertPartialDataFromUiToSdk(
        uiData: DeepPartial<IChartManualLayout>,
        sdkData: DeltaOf<ICTLayout>,
    ) {
        sdkData.manualLayout = sdkData.manualLayout ?? {};

        if (uiData.leftMode !== undefined) {
            sdkData.manualLayout.xMode = { val: uiData.leftMode };
        }
        if (uiData.topMode !== undefined) {
            sdkData.manualLayout.yMode = { val: uiData.topMode };
        }
        if (uiData.left !== undefined) {
            sdkData.manualLayout.x = { val: uiData.left };
        }
        if (uiData.top !== undefined) {
            sdkData.manualLayout.y = { val: uiData.top };
        }
        if (uiData.width !== undefined) {
            sdkData.manualLayout.w = { val: uiData.width };
        }
        if (uiData.height !== undefined) {
            sdkData.manualLayout.h = { val: uiData.height };
        }
    }
}
